import Skeleton from 'react-loading-skeleton'
import ColorSelector from '../ColorSelector'
import * as S from './styles'

const ApparelProductSkeleton = ({
  showProductType = false,
  showSingleVariant = false,
  showReviewBadge = false,
  showSeason = false,
  size = '',
}) => {
  return (
    <S.ApparelCard className={size}>
      <S.Image>
        <Skeleton />
      </S.Image>

      <S.Title>
        <Skeleton />
      </S.Title>

      {showReviewBadge && <S.ProductReviewBadge loading />}
      {showProductType && (
        <S.ProductType>
          <Skeleton />
        </S.ProductType>
      )}
      {showSeason && (
        <S.Season>
          <Skeleton />
        </S.Season>
      )}

      <S.Description>
        <Skeleton width="80%" />
        <Skeleton width="50%" />
        <div className="long-desc">
          <Skeleton width="60%" />
        </div>
      </S.Description>

      <ColorSelector loading center showSkeleton={showSingleVariant} />
      <S.Separator />
      <S.Price>
        <Skeleton />
      </S.Price>
    </S.ApparelCard>
  )
}

export default ApparelProductSkeleton
